{
  "schemaVersion": 1,
  "characters": {
    "m": {
      "soul": [
        "/game/characters/death/m/soul-00.png",
        "/game/characters/death/m/soul-01.png",
        "/game/characters/death/m/soul-02.png",
        "/game/characters/death/m/soul-03.png"
      ],
      "width": 114,
      "height": 95,
      "anchor": {
        "x": 62,
        "y": 83
      },
      "states": {
        "idle": 0,
        "move": 1,
        "smile": 2,
        "cry": 3
      },
      "faceSourceFrames": [
        0,
        10,
        14,
        17
      ],
      "faceScale": 0.75,
      "faceDestination": {
        "x": 7,
        "y": 5
      },
      "faceUpSourceFrame": 36,
      "faceDownSourceFrame": 36,
      "grayMatrix": [
        0.3086,
        0.6094,
        0.082,
        0,
        0,
        0.3086,
        0.6094,
        0.082,
        0,
        0,
        0.3086,
        0.6094,
        0.082,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ],
      "frameRate": 25,
      "loop": true,
      "ghostEffect": "maleGhost"
    },
    "f": {
      "soul": [
        "/game/characters/death/f/soul-00.png",
        "/game/characters/death/f/soul-01.png",
        "/game/characters/death/f/soul-02.png",
        "/game/characters/death/f/soul-03.png"
      ],
      "width": 114,
      "height": 95,
      "anchor": {
        "x": 62,
        "y": 83
      },
      "states": {
        "idle": 0,
        "move": 1,
        "smile": 2,
        "cry": 3
      },
      "faceSourceFrames": [
        0,
        10,
        14,
        17
      ],
      "faceScale": 0.75,
      "faceDestination": {
        "x": 7,
        "y": 5
      },
      "faceUpSourceFrame": 36,
      "faceDownSourceFrame": 36,
      "grayMatrix": [
        0.3086,
        0.6094,
        0.082,
        0,
        0,
        0.3086,
        0.6094,
        0.082,
        0,
        0,
        0.3086,
        0.6094,
        0.082,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ],
      "frameRate": 25,
      "loop": true,
      "ghostEffect": "femaleGhost"
    }
  },
  "effects": {
    "maleGhost": {
      "path": "/game/characters/death/effects/maleGhost/frame-00.png",
      "frames": [
        "/game/characters/death/effects/maleGhost/frame-00.png",
        "/game/characters/death/effects/maleGhost/frame-01.png",
        "/game/characters/death/effects/maleGhost/frame-02.png",
        "/game/characters/death/effects/maleGhost/frame-03.png",
        "/game/characters/death/effects/maleGhost/frame-04.png",
        "/game/characters/death/effects/maleGhost/frame-05.png",
        "/game/characters/death/effects/maleGhost/frame-06.png",
        "/game/characters/death/effects/maleGhost/frame-07.png",
        "/game/characters/death/effects/maleGhost/frame-08.png",
        "/game/characters/death/effects/maleGhost/frame-09.png",
        "/game/characters/death/effects/maleGhost/frame-10.png",
        "/game/characters/death/effects/maleGhost/frame-11.png",
        "/game/characters/death/effects/maleGhost/frame-12.png",
        "/game/characters/death/effects/maleGhost/frame-13.png",
        "/game/characters/death/effects/maleGhost/frame-14.png",
        "/game/characters/death/effects/maleGhost/frame-15.png",
        "/game/characters/death/effects/maleGhost/frame-16.png",
        "/game/characters/death/effects/maleGhost/frame-17.png",
        "/game/characters/death/effects/maleGhost/frame-18.png",
        "/game/characters/death/effects/maleGhost/frame-19.png",
        "/game/characters/death/effects/maleGhost/frame-20.png",
        "/game/characters/death/effects/maleGhost/frame-21.png",
        "/game/characters/death/effects/maleGhost/frame-22.png",
        "/game/characters/death/effects/maleGhost/frame-23.png"
      ],
      "width": 49,
      "height": 35,
      "anchor": {
        "x": 0,
        "y": -28
      },
      "frameRate": 25,
      "sha256": [
        "1a25b425ff2f0e696d5ce19cef2407d6cb081a8188b548782cd1e494a52b6640",
        "1b34736de05c854f7742f958a64bde0bed594a3fec109534fdba1dd152096f0a",
        "0854c235a3ba71a40e3f19d644f1f7ca2ee69eabbdd65d398185d1a447494547",
        "e851f8a387bf890f63735b0ab974417d742c31984b1a22035ead8ab10c9409db",
        "2a4f2d35f76131dc3481d6e44496d43caf2c087a39197eabed7a7e2b48d73697",
        "a6473d22585405eb91c57f331c1a2d6f26c2b7229c687cba0cc2066b8c9985d1",
        "0960442390c206f679832209e1a9b7ced82f78626ea4768df7c97f0fde537d80",
        "61e1fac0ada996b5a1e8bcc41cd8a435e19ae5fa502cc9f306bf13db74b4becf",
        "7a2b972a26fd1e6913536cd3c1821d78fdb19630c6802364b576f0f906a79d29",
        "6b7124706f9f539b3b52762a1e7ff0a232139a02aa04daca5e1e1bd82ce8af78",
        "c83232f0e24bb19b5e48b4e8be8a5f5a35008c18f62f2f104ccbc7d9cb562e03",
        "41b6704edeaa476298cdf53ce987d0e356fa0771a6b36231b65c96361f992565",
        "20d5c582337c0f8fc67593c468e9841116dcd9198731775de04eebdc56bae2b3",
        "b76f4c6e272ee680813674868e599f08901e111c3b76c6696cecd5621dbb71b7",
        "07b9906648424e6ae904802f6a751ccd8fd7b6e1858798652f2dcc6f94da53c8",
        "3b3892f24d88baf8bcbbc509a3073ed3dcc0d706f5865ba085ab5610288cd0d0",
        "b2012d5aecf7c550c85af84a3d781b1b971ceaaef529a4775995553676009141",
        "46692f18077a54cd01a0e8bafdc5ddbc1b5087f29674037c42031e7433c70ffa",
        "6dd35e35fa69d700b84301981a3a2584c4c1676798c7c4ccf5fdca114d40af27",
        "2801693634af18b2ead6c80f639ab0f6e5bb6b8222be6057f4081c8efe342b15",
        "80f1a607fa2a45f5bf345238fb596f2b808bf75eb6f93f2f9d5db09cacae1cdb",
        "1a6142ded476da205d63a87c115f94f91080dac07240173cd0e59806d12bbabb",
        "a6b328d4da2476e9c3bd423cb1dc1593929f747f9697b9729501993df2a2dac6",
        "4aee0c3a50de94b2b8eca483ae42250140bf1f6e6d13d0510563c4b3a0ab43f0"
      ],
      "sourceCharacterId": 481,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameii.swf",
      "sourceSha256": "a3a4343d1ac15e9df64051b330ec8646f2b50d851a0c76c5050fbca510178504",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.game.ghostManMovieAsset",
      "sourceFileFrameRate": 24,
      "loop": true,
      "frameScripts": [],
      "position": {
        "x": -26,
        "y": -50
      },
      "vectorFrameSha256": [
        "8b6bed5774761a6f5f7bed7aadf506fbb5f9d216f561690d4dcc1ce2a1b63a01",
        "58cd2256ccf3a9f42f27d5eedcbe3bb4f493c40635bc92a61f88edc528f0585c",
        "a2fadb45388be488407bb42bee9e3548e9f86eeffcab0181e1936dd38a84cfa0",
        "5f094c7268834e6b3af49110446687159fc39fc40cfffc4d1121dd1398ca205f",
        "3172dbcc4cdb72c9331afd44830a1377b6a0c1d7fc0b04854720acf870d58983",
        "fb9d5611ddf97ef77cb2dc053e93acbd5eee3822e9cd904284febcff2c3e1157",
        "7913c170fd56c51ea5162441d026150783b5b065b25f761cf748757db944d6b7",
        "5e7f55c7c47b5a7dc69d6dc87eff2f1cfcdefba2316eff8082cde1a8db580cc4",
        "8d26b4a21d5d5191c1489e18c598e04354b04f1817301ee9ffa7858b24d02b64",
        "603abe538efab9e3b8cf3f26646ea79504e300b789d17f80dae5d17f31c9c6f2",
        "bdf2c06a6a16432a59af3c1e028ceb73f5e7d295d0df45541ca8bb25c6f6c625",
        "b5baaa033a12522b6efc8bdccd09cc4c5b7eaeab97f0386cc9b62a052d4fd270",
        "119c03d27331f9ed7515287ad6fd079b37aafa895b3ccb4a80a1da97fb78d620",
        "bbb2343ad909a1ba85266dc564048da04d29f3974f2c96f89131f5dd3ec211b0",
        "8bf39b02145e3d27ebbde70e88b6e2f6ddb69a585d6f17115d75ef85f5243516",
        "4c0b58b41fcb8044e51b283ede83b5ecd176cca9bf1a734f6d285c296aff5110",
        "099257b15a30a1447579a4769d85b05bc2af2d7dd3893c1742e855fd0fa7d90a",
        "11ec933d3aed216ca8d9f9780b2b8a469e2a8fd2b2934d28860ec4a3fa7556d0",
        "b458bfdff291d5427a2438b4250e086cbb06271c4b7465d2f11905f3d72f8d19",
        "5c3b928dd5ede6ffade9680dcefb46f77df4c2c604e0f82601c9a38de7ba8db3",
        "bb89262fb89374d380256aad98c01219b8d38689ed9d0d44161796083e1045da",
        "8ac678369ab3a5c654cb15d86fa164450c0aff8a67d7e2742f74e5a7f27b92a3",
        "bde406f82a0397b88f393894924a0b663b3041899a359aa6e8171eb01eb7b4e1",
        "8d6b53bf886e8c78a45bf2c595d15e63a717d53c3ecf00317d8cc41047cccf14"
      ]
    },
    "femaleGhost": {
      "path": "/game/characters/death/effects/femaleGhost/frame-00.png",
      "frames": [
        "/game/characters/death/effects/femaleGhost/frame-00.png",
        "/game/characters/death/effects/femaleGhost/frame-01.png",
        "/game/characters/death/effects/femaleGhost/frame-02.png",
        "/game/characters/death/effects/femaleGhost/frame-03.png",
        "/game/characters/death/effects/femaleGhost/frame-04.png",
        "/game/characters/death/effects/femaleGhost/frame-05.png",
        "/game/characters/death/effects/femaleGhost/frame-06.png",
        "/game/characters/death/effects/femaleGhost/frame-07.png",
        "/game/characters/death/effects/femaleGhost/frame-08.png",
        "/game/characters/death/effects/femaleGhost/frame-09.png",
        "/game/characters/death/effects/femaleGhost/frame-10.png",
        "/game/characters/death/effects/femaleGhost/frame-11.png",
        "/game/characters/death/effects/femaleGhost/frame-12.png",
        "/game/characters/death/effects/femaleGhost/frame-13.png",
        "/game/characters/death/effects/femaleGhost/frame-14.png",
        "/game/characters/death/effects/femaleGhost/frame-15.png",
        "/game/characters/death/effects/femaleGhost/frame-16.png",
        "/game/characters/death/effects/femaleGhost/frame-17.png",
        "/game/characters/death/effects/femaleGhost/frame-18.png",
        "/game/characters/death/effects/femaleGhost/frame-19.png",
        "/game/characters/death/effects/femaleGhost/frame-20.png",
        "/game/characters/death/effects/femaleGhost/frame-21.png",
        "/game/characters/death/effects/femaleGhost/frame-22.png",
        "/game/characters/death/effects/femaleGhost/frame-23.png",
        "/game/characters/death/effects/femaleGhost/frame-24.png",
        "/game/characters/death/effects/femaleGhost/frame-25.png",
        "/game/characters/death/effects/femaleGhost/frame-26.png",
        "/game/characters/death/effects/femaleGhost/frame-27.png",
        "/game/characters/death/effects/femaleGhost/frame-28.png",
        "/game/characters/death/effects/femaleGhost/frame-29.png",
        "/game/characters/death/effects/femaleGhost/frame-30.png",
        "/game/characters/death/effects/femaleGhost/frame-31.png",
        "/game/characters/death/effects/femaleGhost/frame-32.png",
        "/game/characters/death/effects/femaleGhost/frame-33.png",
        "/game/characters/death/effects/femaleGhost/frame-34.png",
        "/game/characters/death/effects/femaleGhost/frame-35.png",
        "/game/characters/death/effects/femaleGhost/frame-36.png",
        "/game/characters/death/effects/femaleGhost/frame-37.png",
        "/game/characters/death/effects/femaleGhost/frame-38.png",
        "/game/characters/death/effects/femaleGhost/frame-39.png",
        "/game/characters/death/effects/femaleGhost/frame-40.png",
        "/game/characters/death/effects/femaleGhost/frame-41.png",
        "/game/characters/death/effects/femaleGhost/frame-42.png",
        "/game/characters/death/effects/femaleGhost/frame-43.png",
        "/game/characters/death/effects/femaleGhost/frame-44.png",
        "/game/characters/death/effects/femaleGhost/frame-45.png",
        "/game/characters/death/effects/femaleGhost/frame-46.png",
        "/game/characters/death/effects/femaleGhost/frame-47.png"
      ],
      "width": 47,
      "height": 34,
      "anchor": {
        "x": -1,
        "y": -27
      },
      "frameRate": 25,
      "sha256": [
        "fed5a43aea26866d7dea5e59c0dbd40b91daf92a5cc588a7de78bd21b48a3d7b",
        "228ed8edb70d5d6819ce215bdbbc7f37e41624f2f8b9647a9c4c3d639b7898b1",
        "fa70304a83f5b770903a39a382b24944044402b729751746294c21c85b390fab",
        "59ac270f7c05de010b2ee17f9b186e80fb81b81a8ffd72c89ae2f5741fb7c883",
        "49c1ed3376ec49a13b9c2654d0a5e160fca6925d631d0fe4847911268654f4b2",
        "49c1ed3376ec49a13b9c2654d0a5e160fca6925d631d0fe4847911268654f4b2",
        "7ffdf2195be01a4685f6a1b322caf28d86a33866d1022c3f8236434e6d4cb2ac",
        "7ffdf2195be01a4685f6a1b322caf28d86a33866d1022c3f8236434e6d4cb2ac",
        "52df1d4ab5f135432f5fe08d139a4557470f08597cee4a14b0c05691316eba76",
        "0e9adf750703b0e01ff7f1c79a6baeaa9df85aef35c26eee95cca4ef163e39c4",
        "da8f11082b1865688412b926dde279b3261c6bf6c3e648536018d3dbfde7d209",
        "93ce7d877f6a8e44c6878c1510beeed488d0592ced0f5fc22080faeaa5efe82a",
        "8fbb7a329f9cc97b4b69618437a8e36466f0b703ba1b4ca1274d2b512d4d66b7",
        "45e0c5a368f27183c33638157229d3e368501727192ca4fcc12427c10dd2bd33",
        "527b619ca7062160c092baa688ca3e0999a28c9d3419762c9759259a9b637e63",
        "a35238c06509cfa81dd13d4097f73d8cc2e6cc52ad7e1297af45533e1caecf11",
        "25629c8a0ff5f1be82ea2a5484b402177680fc67730775f094a5a07001fd9293",
        "e9bdc93b75b03cbefde52eb8d366458a3a4e733e85c88a6227875fefe3a32c3c",
        "04bd642b29d4c8f8388b467695c542a7a8adcd1c3b4e168449a51759efd99046",
        "04bd642b29d4c8f8388b467695c542a7a8adcd1c3b4e168449a51759efd99046",
        "b37253943a90682086e35c2ad1b736f4a4dcd974cb32099131fe4ef90048009e",
        "925e3d4f92e8e8436cd45796ba7ec28aa93705a663bfce1f0b3637a33c54d102",
        "18add1817f016bf11a9ba12e4cc1e699fc444524ca544387dd2460ca9f05cebf",
        "a54f1843f8b3a3e35e50e5926f18fd8406f2ff96f101e44e7d42c83603a37cfa",
        "f7053e0e2088e340043cb24c2c7de8c4b39d27e61fbf655f4caaf46bb2fde6bd",
        "f7053e0e2088e340043cb24c2c7de8c4b39d27e61fbf655f4caaf46bb2fde6bd",
        "e68aa8f8e1c33df14f9bcf576b981960c116f236bb4a05dae3cbe5ee884c58d9",
        "f11bff817a28b70d854d7180bb269c3dbb6e2fba9252aee8088eb806df852bc1",
        "11efc91fbaf06863d17845bb9244dbd79c510b5cdc00f175f42f68b1b39b625e",
        "edaeb96d94bd79bcb49995c93773030534743807c1223adce7c4021be4c4ad5a",
        "7f3cfceebd46d0c0ec9a5f92872b80589e7bf4c5d494d7fb5eb5529422950f5f",
        "4235ba42f8d1ad3e09619cec9a14a3fbf62e01d1da1aac9e8918c424b2771a59",
        "ea457f7f97ecff058144c0023513dbbb85da6fde1d8456d68ea7937e43a7abc7",
        "a9fc0c3a2179071fcc7ac826401e2d647a5b7d0c1333ce0e29fd4d3ee45cdbc3",
        "3edd387f1907185d78bf356f9429d4ae345ea56b3520bbb0deff2a06f36f119e",
        "3edd387f1907185d78bf356f9429d4ae345ea56b3520bbb0deff2a06f36f119e",
        "8dd9ab07b39d1aef93524157a6991f159c06c169d6128a38f271797eb2b6d28e",
        "383c6f383679f68d6fb77c7b1144c662726e05e35e3efed40c0756acdd85fc29",
        "ae876db61d8a12019ce6c143cd6a89956e8b48b153be9d0fd6d7eb6349c0fc0f",
        "30c3acbc6645e1181a6b575471f92d23b739b6118455a4ffd71a348451524eb8",
        "849a100c1cbd14f9db772624b4be0c412c9e5b12b16290ef8e4c531b6e4fb636",
        "849a100c1cbd14f9db772624b4be0c412c9e5b12b16290ef8e4c531b6e4fb636",
        "fd4b697cc708c8aff2d9626b53a0531c4ecefa61e5daa312212a9b6ef4eb497d",
        "fd4b697cc708c8aff2d9626b53a0531c4ecefa61e5daa312212a9b6ef4eb497d",
        "02b0395519141784e05ea8d02d4ad1920be0add33d393b7a0877f211a272b5dc",
        "186b6d92d91dd598604814bfbc98dda7bf4a1aa7bd8690c7b447494cd4475674",
        "e85135b7546e3ce195b90259cea234191630db7cdf815429778d086844198a72",
        "c3eaa0e67806c5ff96c2011a0668428ae877b82e54574b4bd5eb249e02b03fdd"
      ],
      "sourceCharacterId": 489,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameii.swf",
      "sourceSha256": "a3a4343d1ac15e9df64051b330ec8646f2b50d851a0c76c5050fbca510178504",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.game.ghostGirlMovieAsset",
      "sourceFileFrameRate": 24,
      "loop": true,
      "frameScripts": [],
      "position": {
        "x": -26,
        "y": -50
      },
      "vectorFrameSha256": [
        "3d9a1259d73a78c31ca66593809ab3867329afd77ce09dc64b0d1bd1e2654def",
        "7c5256fb0d7f5d86b88b562af7ca968f57f15027f6d9973b97dcebf964516921",
        "2d6bc43bb18ac02be2d6ee5fa1ffb564eaab549958d443f6e74e5de482960061",
        "5f795fa4bc5bfd36873f4531365a576318a506d21f5b4b8dc3db709ce42abf3f",
        "a73b41b28d530e9a5f5beb3c8e386727bd7af7516a17d33b9d3bb5cc6cf82323",
        "d376090fd4aedd1233358893d35f36767779d0c49049040a68e75123026ef988",
        "bccdb0da123d2cf71efef06ac37970d82f9aab7f61370818fda9d5851d8f3445",
        "7218c0649b25ef66468d83b5b0cf2d3f81dec9275d7e2dcf79657c11012eee8d",
        "37f7f6edbf9580e911fa35aa8415b94efb2d1643dfce49844f4ddf2cf0ffe1c5",
        "79b5180639f2e17a635d2ddb49fa3f328067df5ed675cbad42cad379ef7e53d2",
        "c111c1b5507c25552dc9b28a273d06c04dec5854cbb0a19579a89ad0b2f956e9",
        "01048168a1605bc1c3e7e20622dac9d5685981348555258534b5652c4ab905d1",
        "18c2653a0d71f2f3eb851077a072f69759a316036d4bd4f0af83856da3a60a90",
        "6bdde95945acca873130d8cdd936eaf8ebb0e866ba0e0fbf6d89441cb03dda9f",
        "0b5e2cec1f39540bfc9c365b402f4c6449053296d43bd5b582c37670eb746343",
        "0188eac7efdc4bc8b83c79b1e82994cba24430e64dbb51a0ecaf0d5468b094e7",
        "5e044779be8f2598050b811d8ee81668456d31274628b8fbc3ba13d0dc208f1b",
        "c3d6230074c7289d8772ca68d67c5696a49e0bd68d990703305db775a61e58d0",
        "aea0fd98d1bd27303513f8e718937c2268134ff72ec6bfb65e05da93fd0171df",
        "bb0aaf230a16b6ac8c5847ef7652f9ee0eab12f4ddba12985c455415caec4dfa",
        "a01b3860e9f4a29d5c4bcb80307defcb902b38a1e7c895c6ffe7ca1d0294c897",
        "d29e1751f4ebfd7682c16c152e042320f7c7e3f47a25401882befd50e274ac8c",
        "553bfe7e1c7cd7c7b18db560a64505f2ec0113d29bf9753547c117ce1e183a62",
        "95b509ac1cbd5ae0a5d0b65fce55c499d348482b651f3cb1d1b401c25e487fa9",
        "838ccfa76055f64a57a5e68cd813b68c7c4b8827fdb1626969b47dbec90ff77b",
        "e69e434b61fc1fa44601ce4be2e78a7a7a7b83f051cc87cd3411b6533257c8ff",
        "83c64d1458c757998dda130da3191e544f3dd743ab02ec957eddf71afb1d3f78",
        "aff091061e3dac7cc09875547c9ca12e569d21a45b2b4f42a7ab15fbd42063e2",
        "4d863271865a36fb77ab7c66d543bd3c9f7cdea8585b61de8a903b2d1f0edae0",
        "52d844e6276629801ffc4f3e25c8a2c9deedba2f85d5d44e7f094f335fefac3e",
        "e8bba0bacd33401343b61ec403b179f0c9d4e30a8da97ce1c467ba928768661b",
        "bd4c1e0b5e14254604e5fa7a45b24b4e9c8022716fb0a399f882d0ce0dd4cf00",
        "f2d1dd726dce97391631b17d39ef2a25979b6c4ead9311f3465639c8297baf12",
        "cd3692f25f09acae28a13bb084b4e6ddde367d705a4dce8280cdceb0ad1a6d8f",
        "00018ac2140fedb8b68aba1e8737a07e5cb2707544aeed0b1cd1f073e54fb3d7",
        "9ecb8f0c294ec51b1f8e833254a8eb321f84759d9cb0c5060d930ca33acc94e6",
        "6268ea96701f69079fc4caf0b59b2f1c5a04a4f7ed8fc67d151e8d03a4bbf557",
        "04f7f428ee7a128013c9736d1e1ee5e28709c09a817fb6dab037fd1f42b0476d",
        "d5ac116eb35a280170daf14616e4ecc57d67a34099e5acd7529dacb1679ba6bb",
        "7cbaefe601bf75b4dbcf9df7287a72d68bc70b66269ff93a42b48f497e490c18",
        "293e29b170f252553ed3c805453b8909413e0419cf7e664795085ef416fe72ac",
        "b38024623baa930ad9a34890b030753974d474d1be435a772dacbe5f4572aca1",
        "d6e4e384556070f010ac6244ab805160d6bada8e4a790e625142d408556a1945",
        "6c66b721361ce46e3de1c85d67372d1abc4362edacaf7a28e2cedd21697a8b9d",
        "1900dc2d07a850ff0ac101f1c841a2fd57d2cf785d3b93a25e5bf00c34049c72",
        "3f98d6edfc56e99cfe9b84be8c534bb4c8cb9d4e40090a8a43bd01b4e84bc7c0",
        "55e760a6e80714b6ff9ad1270b235efb69622733ca0a84c5e01251bbb36e4e7c",
        "18f616fe9fdd365aa776dd3a40c5eb350e0a488c5a87413a861116927dfcb833"
      ]
    },
    "ghostShine": {
      "path": "/game/characters/death/effects/ghostShine/frame-00.png",
      "frames": [
        "/game/characters/death/effects/ghostShine/frame-00.png",
        "/game/characters/death/effects/ghostShine/frame-01.png",
        "/game/characters/death/effects/ghostShine/frame-02.png",
        "/game/characters/death/effects/ghostShine/frame-03.png",
        "/game/characters/death/effects/ghostShine/frame-04.png",
        "/game/characters/death/effects/ghostShine/frame-05.png",
        "/game/characters/death/effects/ghostShine/frame-06.png",
        "/game/characters/death/effects/ghostShine/frame-07.png",
        "/game/characters/death/effects/ghostShine/frame-08.png",
        "/game/characters/death/effects/ghostShine/frame-09.png",
        "/game/characters/death/effects/ghostShine/frame-10.png",
        "/game/characters/death/effects/ghostShine/frame-11.png",
        "/game/characters/death/effects/ghostShine/frame-12.png",
        "/game/characters/death/effects/ghostShine/frame-13.png",
        "/game/characters/death/effects/ghostShine/frame-14.png",
        "/game/characters/death/effects/ghostShine/frame-15.png",
        "/game/characters/death/effects/ghostShine/frame-16.png",
        "/game/characters/death/effects/ghostShine/frame-17.png",
        "/game/characters/death/effects/ghostShine/frame-18.png",
        "/game/characters/death/effects/ghostShine/frame-19.png",
        "/game/characters/death/effects/ghostShine/frame-20.png",
        "/game/characters/death/effects/ghostShine/frame-21.png",
        "/game/characters/death/effects/ghostShine/frame-22.png",
        "/game/characters/death/effects/ghostShine/frame-23.png",
        "/game/characters/death/effects/ghostShine/frame-24.png",
        "/game/characters/death/effects/ghostShine/frame-25.png",
        "/game/characters/death/effects/ghostShine/frame-26.png",
        "/game/characters/death/effects/ghostShine/frame-25.png",
        "/game/characters/death/effects/ghostShine/frame-24.png",
        "/game/characters/death/effects/ghostShine/frame-23.png",
        "/game/characters/death/effects/ghostShine/frame-22.png",
        "/game/characters/death/effects/ghostShine/frame-21.png",
        "/game/characters/death/effects/ghostShine/frame-20.png",
        "/game/characters/death/effects/ghostShine/frame-19.png",
        "/game/characters/death/effects/ghostShine/frame-18.png",
        "/game/characters/death/effects/ghostShine/frame-17.png",
        "/game/characters/death/effects/ghostShine/frame-16.png",
        "/game/characters/death/effects/ghostShine/frame-15.png",
        "/game/characters/death/effects/ghostShine/frame-14.png",
        "/game/characters/death/effects/ghostShine/frame-13.png",
        "/game/characters/death/effects/ghostShine/frame-12.png",
        "/game/characters/death/effects/ghostShine/frame-11.png",
        "/game/characters/death/effects/ghostShine/frame-10.png",
        "/game/characters/death/effects/ghostShine/frame-09.png",
        "/game/characters/death/effects/ghostShine/frame-08.png",
        "/game/characters/death/effects/ghostShine/frame-07.png",
        "/game/characters/death/effects/ghostShine/frame-06.png",
        "/game/characters/death/effects/ghostShine/frame-05.png",
        "/game/characters/death/effects/ghostShine/frame-04.png",
        "/game/characters/death/effects/ghostShine/frame-03.png",
        "/game/characters/death/effects/ghostShine/frame-02.png",
        "/game/characters/death/effects/ghostShine/frame-01.png",
        "/game/characters/death/effects/ghostShine/frame-00.png"
      ],
      "width": 55,
      "height": 68,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sha256": [
        "62efba78a8e03383b98ec88532b1855122b643fe2074656113bcfac420446c9d",
        "b5d14cf8878d74b97dc73a3b84c54d742ede2442e03c8a46e732659819ca56e4",
        "f340990e01beee85d6260e2b374ab872ccd648d45625c0751717398425e3bc2b",
        "b49fe8e94bb63fc292b19faec0bcc26bd585c418be64cd5374f5f272e57c8bf8",
        "c33a022aca50df3ac76ef3579dfcd8030a11ec028ec4e67ff458483e7bc420cf",
        "09804b6582e9f95766422e4b5a3dd6e1f0aa66f3925033ba00b9ad86e48f958e",
        "963b28cca2889102b69a4ffd04d1d899afdcddde8b02e6231ca67f40e2b8712c",
        "ee015da3584465b427aff3c24832fd9340e957871040c1cf5b631cbcd3fd8b2a",
        "7eed41434440d8918d23b3e4ce6cec3caf0e7303c5d37a9ab2ba259419edafe9",
        "07e6537170cca3af692c6d09ff29ece8f086097ac37402e1949ff0a28cf15627",
        "b81a046f25963d14899bcd9fbe15b95ad2a4a1d1a74fd12a0a4edea87bf2f717",
        "c3024f49ed9510b60cd06d36714728e008b596a8788cf04706879c16c6e40e42",
        "60417f3de7904eaed7929800173760e4ce4797b0905f192676c3b25756a84640",
        "7ee7e3932ddd1b1769a54b6e314fda418c2a30eb381b48b0c1bbc7d13993fdc1",
        "173ad28e028f7bd40c4f49f6f209216da7f939029e84853a85d5fe1847c2eac1",
        "1eea94e2cf002f7683dfca51cc241726e8fef861d550b449593b0de4d69e9f47",
        "6ed3ea5761a2a5af00d449687faa19e1fb0e972b840ff8ffcf844d28f8c19b62",
        "d82f0edcf20c055f1bccb9408e8b19cc989181f5698d565223a49929dd3b9e96",
        "ec1d70a79cf6299957f0c42dee50fd1c3f216c97780deb470139274d5e4c5b1e",
        "83a136e37cc6fde497734f843c308d1de06dcd55011b513c49abaec924b26e12",
        "91912562eb7e58020798c814e973db71ad3646746f334b5a91f3c5b84a5adcb8",
        "75176083cf70c1462ad7d7d9fe3c48be89383305bcbe10fcdf5e16e4ebfbad60",
        "186efb384ab0a30776a55142ab189f52f30b103908b26271d2761dd431f4fc72",
        "b055dff875a21893cbdbfc28b2304f9e45ea77d6d22945bcdde442e600e3f3e8",
        "7f3dd2f4fa46f9466b5058a08473606444d012ab0426c917f0f78e09e6a38218",
        "b9f58a2d6b659e8cb276ebcf209c1f6e68418cd4a5becee302c0bcecac60c5c5",
        "1a0670bc49094502af5d2bc08007840363411f4d0d27c440162eb5f2166f9444",
        "b9f58a2d6b659e8cb276ebcf209c1f6e68418cd4a5becee302c0bcecac60c5c5",
        "7f3dd2f4fa46f9466b5058a08473606444d012ab0426c917f0f78e09e6a38218",
        "b055dff875a21893cbdbfc28b2304f9e45ea77d6d22945bcdde442e600e3f3e8",
        "186efb384ab0a30776a55142ab189f52f30b103908b26271d2761dd431f4fc72",
        "75176083cf70c1462ad7d7d9fe3c48be89383305bcbe10fcdf5e16e4ebfbad60",
        "91912562eb7e58020798c814e973db71ad3646746f334b5a91f3c5b84a5adcb8",
        "83a136e37cc6fde497734f843c308d1de06dcd55011b513c49abaec924b26e12",
        "ec1d70a79cf6299957f0c42dee50fd1c3f216c97780deb470139274d5e4c5b1e",
        "d82f0edcf20c055f1bccb9408e8b19cc989181f5698d565223a49929dd3b9e96",
        "6ed3ea5761a2a5af00d449687faa19e1fb0e972b840ff8ffcf844d28f8c19b62",
        "1eea94e2cf002f7683dfca51cc241726e8fef861d550b449593b0de4d69e9f47",
        "173ad28e028f7bd40c4f49f6f209216da7f939029e84853a85d5fe1847c2eac1",
        "7ee7e3932ddd1b1769a54b6e314fda418c2a30eb381b48b0c1bbc7d13993fdc1",
        "60417f3de7904eaed7929800173760e4ce4797b0905f192676c3b25756a84640",
        "c3024f49ed9510b60cd06d36714728e008b596a8788cf04706879c16c6e40e42",
        "b81a046f25963d14899bcd9fbe15b95ad2a4a1d1a74fd12a0a4edea87bf2f717",
        "07e6537170cca3af692c6d09ff29ece8f086097ac37402e1949ff0a28cf15627",
        "7eed41434440d8918d23b3e4ce6cec3caf0e7303c5d37a9ab2ba259419edafe9",
        "ee015da3584465b427aff3c24832fd9340e957871040c1cf5b631cbcd3fd8b2a",
        "963b28cca2889102b69a4ffd04d1d899afdcddde8b02e6231ca67f40e2b8712c",
        "09804b6582e9f95766422e4b5a3dd6e1f0aa66f3925033ba00b9ad86e48f958e",
        "c33a022aca50df3ac76ef3579dfcd8030a11ec028ec4e67ff458483e7bc420cf",
        "b49fe8e94bb63fc292b19faec0bcc26bd585c418be64cd5374f5f272e57c8bf8",
        "f340990e01beee85d6260e2b374ab872ccd648d45625c0751717398425e3bc2b",
        "b5d14cf8878d74b97dc73a3b84c54d742ede2442e03c8a46e732659819ca56e4",
        "62efba78a8e03383b98ec88532b1855122b643fe2074656113bcfac420446c9d"
      ],
      "sourceCharacterId": 457,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameii.swf",
      "sourceSha256": "a3a4343d1ac15e9df64051b330ec8646f2b50d851a0c76c5050fbca510178504",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.game.ghostShineAsset",
      "sourceFileFrameRate": 24,
      "loop": true,
      "frameScripts": [],
      "position": {
        "x": -28,
        "y": -50
      },
      "vectorFrameSha256": [
        "e3a44564863229cd86a3a66084c2c078b0b1a33606ebd5da39dd2202184be6a0",
        "84d23932149e1caf984e3a3be4a864937970b003730ad45f83667e10305f77a6",
        "99f5379ac9fb3b233797ce20c2abe6c5bc5068db3f73b85aae720a1a55bdc32f",
        "f977ce68fd04e43f242f126491ef0d6128548c004330174bf3a874d1612156de",
        "db10aaea3ac610b4d14b2af2c15b8040f31fbd979ef43ac887558f091614bff6",
        "d82b0c484d51c01caef7fb4d8911ddcb17e2eb69608ef40d9a19d90b3408b31b",
        "7896e8e1ad6d70360481996e0031df55d0381bd73e5c95f54ba6c73931e68224",
        "e85b607892063df9f048a1ca07a5183e3fadf6aff592c45e0f99491ac3655701",
        "3ac4527a7f6bcc4ed5ca4385665c8f8b650d2b27fd0ca7ccd85a68b398f7103e",
        "671e5a5c5a3a56452391c4aa160de1e0abed8553ccdcd40b091087c7b724686e",
        "7cfc09b148b1d30040be238bfb1f4be92dfee1106814f7e82384c38512e11646",
        "6dbc9d1edb9a3fb8fd6a2cd1d2e65b6b8585f392a858c4731547193adc95c190",
        "cb7a614e7617cf7fe20de03b2001f79fee20431c09ae1ac93a320881b78b7757",
        "28889ce1a895da01ce28c8d93f84a198947c3a54494f07dd2a6acd6150fed814",
        "c543f8bd3febcc1385f3677aa5a1ab6ae5f6963b4c80cff3ba6076f323b6269f",
        "989330dfc45db9aefeb59a9851f4c8d7fea91e362f9d84abaf4fd6319becd699",
        "6e8ae026bc3bf24d3d1b5f40490fb66a4236faccf259b49eaa007ff93a370ff2",
        "b2bdd3592a068d5c51e249371d9e000a52227c98c352b0b360817715d244cd4e",
        "2db84a012af6f2d92e7bfac7bb5d1924ebdd2237301441794d497316574e7555",
        "1f59c94eab822e6930df2c392283c18b6394644f63ccc5fdbc27df2c6adbece3",
        "e9028f20c79dfe77c61bfd2de79b7461e9bcd078b801f145cadb1bdccb85bfe8",
        "dfd6d1a53848bf69d74e26f9532d352bb0e264c6dda3b733babc17a3b3144075",
        "ddfe71689a27be5ab441447a5ee57d0871bd99d5caf9ab718033b4638cf704d3",
        "29b6df21903feae8955c28e9c9fbe730db3a14d67323d0965ea78307f08b8387",
        "7a05781bf2e9af3b56c31e627d650ad23b3ba141ef8e3a2ef4360d8e37db0895",
        "235e1e5995364b419ddd5e9512e3eeac82cb1e1f3da7b03d878e39152ab4932f",
        "62282efe5a93cfd6eadc5cbc734d11448708de54fd576d51b374d6586fa75370",
        "235e1e5995364b419ddd5e9512e3eeac82cb1e1f3da7b03d878e39152ab4932f",
        "7a05781bf2e9af3b56c31e627d650ad23b3ba141ef8e3a2ef4360d8e37db0895",
        "29b6df21903feae8955c28e9c9fbe730db3a14d67323d0965ea78307f08b8387",
        "ddfe71689a27be5ab441447a5ee57d0871bd99d5caf9ab718033b4638cf704d3",
        "dfd6d1a53848bf69d74e26f9532d352bb0e264c6dda3b733babc17a3b3144075",
        "e9028f20c79dfe77c61bfd2de79b7461e9bcd078b801f145cadb1bdccb85bfe8",
        "1f59c94eab822e6930df2c392283c18b6394644f63ccc5fdbc27df2c6adbece3",
        "2db84a012af6f2d92e7bfac7bb5d1924ebdd2237301441794d497316574e7555",
        "b2bdd3592a068d5c51e249371d9e000a52227c98c352b0b360817715d244cd4e",
        "6e8ae026bc3bf24d3d1b5f40490fb66a4236faccf259b49eaa007ff93a370ff2",
        "989330dfc45db9aefeb59a9851f4c8d7fea91e362f9d84abaf4fd6319becd699",
        "c543f8bd3febcc1385f3677aa5a1ab6ae5f6963b4c80cff3ba6076f323b6269f",
        "28889ce1a895da01ce28c8d93f84a198947c3a54494f07dd2a6acd6150fed814",
        "cb7a614e7617cf7fe20de03b2001f79fee20431c09ae1ac93a320881b78b7757",
        "6dbc9d1edb9a3fb8fd6a2cd1d2e65b6b8585f392a858c4731547193adc95c190",
        "7cfc09b148b1d30040be238bfb1f4be92dfee1106814f7e82384c38512e11646",
        "671e5a5c5a3a56452391c4aa160de1e0abed8553ccdcd40b091087c7b724686e",
        "3ac4527a7f6bcc4ed5ca4385665c8f8b650d2b27fd0ca7ccd85a68b398f7103e",
        "e85b607892063df9f048a1ca07a5183e3fadf6aff592c45e0f99491ac3655701",
        "7896e8e1ad6d70360481996e0031df55d0381bd73e5c95f54ba6c73931e68224",
        "d82b0c484d51c01caef7fb4d8911ddcb17e2eb69608ef40d9a19d90b3408b31b",
        "db10aaea3ac610b4d14b2af2c15b8040f31fbd979ef43ac887558f091614bff6",
        "f977ce68fd04e43f242f126491ef0d6128548c004330174bf3a874d1612156de",
        "99f5379ac9fb3b233797ce20c2abe6c5bc5068db3f73b85aae720a1a55bdc32f",
        "84d23932149e1caf984e3a3be4a864937970b003730ad45f83667e10305f77a6",
        "e3a44564863229cd86a3a66084c2c078b0b1a33606ebd5da39dd2202184be6a0"
      ]
    },
    "tomb": {
      "path": "/game/characters/death/tomb.png",
      "width": 50,
      "height": 52,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "position": {
        "x": -20,
        "y": -50
      },
      "symbol": "asset.game.tombAsset",
      "sourceCharacterId": 23,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/game.swf",
      "sourceSha256": "41a8df7976f82b1bf476b6f2bd8c145a23eeabdfc2f8cf92f7172cee4ce1cbe4",
      "sha256": "1443e744e074184b9905eb8927be0d9c19cd5132c69e220ea3d0c81dc4eb6e5b",
      "derivation": "Exact decoded original embedded bitmap without crop or repaint"
    }
  },
  "sourceRules": {
    "ordinaryRoomDeath": "GamePlayer.die creates TombView at death position, starts tomb movement, moves soul root to y-70, sets _player.y25 and rotation0, then enters SOUL. Original Sound042 is owned by the existing audio mapping.",
    "soulRootOffset": {
      "x": 0,
      "y": -70
    },
    "soulPlayerOffset": {
      "x": 0,
      "y": 25
    },
    "soulBodyXByFacing": {
      "right": -6,
      "left": -13
    },
    "soulContainerMirror": "-face; bitmap itself has native GameCharacter scaleX=-1",
    "soulBitmapAnchor": {
      "x": 62,
      "y": 83
    },
    "soulRotation": 0,
    "ghostMoviePosition": {
      "x": -26,
      "y": -50
    },
    "ghostShinePosition": {
      "x": -28,
      "y": -50
    },
    "ghostDrawOrder": [
      "soulBitmap",
      "genderGhostMovie",
      "ghostShine"
    ],
    "glowFilter": {
      "color": 7564475,
      "alpha": 1,
      "blurX": 6,
      "blurY": 6,
      "strength": 2,
      "quality": 1,
      "inner": false,
      "knockout": false
    },
    "tomb": {
      "bitmapPosition": {
        "x": -20,
        "y": -50
      },
      "spritePosition": {
        "x": 0,
        "y": 3
      },
      "testRect": {
        "x": -3,
        "y": 3,
        "width": 6,
        "height": 3
      },
      "physicalLayer": 4,
      "settledSpriteRotation": "PhysicalObj.calcObjectAngle()",
      "physicsConstructorArgs": [
        -1,
        1,
        5,
        50
      ]
    },
    "soulBlink": {
      "initialEyeTicks": 4,
      "eyeFrame": 1,
      "idleFrame": 0,
      "idleBlinkProbabilityPerUpdate": 0.008
    },
    "frameRate": 25
  },
  "evidence": "Pinned later original death behavior and exact archived death pixels/symbols. Exact2009 chronology remains unverified; no generated or redrawn replacement.",
  "rasterization": {
    "renderer": "@resvg/resvg-js",
    "version": "2.6.2",
    "sourceScale": 1,
    "derivation": "Original recovered SWF paths including filled LINESTYLE2 outlines at native dimensions; no redraw or ActionScript execution."
  }
}
